import { TILE_LIBRARY_TYPES } from '../../../state/map/tiles/constants';
import TollRoutes from './TollRoutes';
import { Polyline } from 'react-leaflet';
import HereRoute from '../routes/HereRoute';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [TILE_LIBRARY_TYPES.LEAFLET]: TollRoutes(Polyline),
  [TILE_LIBRARY_TYPES.JSLA]: TollRoutes(HereRoute),
};
